export enum EnrolmentStatus {
  Confirmed = 0,
  Pending = 1,
  // Rejected status renamed to NotEligible
  NotEligible = 2,
  WaitListed = 3,
  Withdrawn = 4,
}
